<template>
  <v-container class="no-margins">      
    <v-data-table class="mt-0"
      :headers="[
        {text: 'Namn', value: 'firstName', groupable: false},
        {text: $t('labels.mobilephone'), value: 'mobilephone', groupable: false},
        {text: $t('labels.email2'), value: 'email', groupable: false},
        {text: $t('labels.date'), value: 'createdAt', groupable: false},
        {text: $t('labels.status'), value: 'state.name', groupable: false},
        {text: $t('labels.show-application'), value: 'id', groupable: false, sortable: false, visibility: 'hidden-xs-only'}
      ]"
      :items="departments"
      sort-by="firstName"
      group-by="depName"
      item-key="uniqId"
      :show-group-by="false"
    >      
      <template v-slot:group.header="{group, headers, toggle, isOpen}">
        <td :colspan="headers.length">
          <v-btn @click="toggle" x-small icon :ref="group"> </v-btn>
          <h4 class="mb-0">{{ group }}</h4>
        </td>
      </template>
      <!-- header first name -->
      <template slot="item.firstName" slot-scope="props">
        <!-- <th v-if="$vuetify.breakpoint.xsOnly" class="overline mt-8 pt-4">{{ $t('labels.name') }}</th> -->
        <div>{{ props.item.firstName }} {{ props.item.lastName }}</div>
      </template>
      <!-- header mobilephone -->
      <template slot="item.mobilephone" slot-scope="props">
        <!-- `<th>mobilephone</th>` -->
        <!-- <th v-if="$vuetify.breakpoint.xsOnly" class="overline">{{ $t('labels.mobile') }}</th> -->
        <div>
          <a v-bind:href="'tel:' + props.item.mobilephone">{{ props.item.mobilephone }}</a>
        </div>
      </template>
      <!-- header email -->
      <template slot="item.email" slot-scope="props">
        <!-- `<th>email</th>` -->
        <!-- <th v-if="$vuetify.breakpoint.xsOnly" class="overline">{{ $t('labels.email') }}</th> -->
        <div>
          <a v-bind:href="'mailto:' + props.item.email">{{ props.item.email }}</a>
        </div>
      </template>
      <!-- header createdAt -->
      <template slot="item.createdAt" slot-scope="props">
        <!-- `<th>createdAt</th>` -->
        <!-- <th v-if="$vuetify.breakpoint.xsOnly" class="overline">{{ $t('labels.date') }}</th> -->
        <div>{{ props.item.createdAt | date }}</div>
      </template>
      <!-- header stateId -->
      <template slot="item.state.name" slot-scope="props">
        <!-- `<th>stateId</th>` -->
        <!-- <th v-if="$vuetify.breakpoint.xsOnly" class="overline">{{ $t('labels.status') }}</th> -->
        <div class="v-data-table__wrapper__state">
          <v-icon>{{ applicationIconByName(props.item.state.state) }}</v-icon>
          {{ props.item.state.name }}
        </div>
      </template>
      <!-- header action buttons -->
      <template slot="item.id" slot-scope="props">
        <ActionButton type="action center" @click="showApplication(props.item.id)">{{
          $t('labels.show-application')
        }}</ActionButton>
      </template>
    </v-data-table>
    <!-- Used to scroll applications on mobile versions -->
    <!-- <EndlessScroll @fetchMore="listenScroll" v-if="$vuetify.breakpoint.smAndDown" /> -->
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import find from 'lodash/find'
import uniq from 'lodash/uniq'
import uniqBy from 'lodash/uniqBy'
import groupBy from 'lodash/groupBy'
import sortBy from 'lodash/sortBy'
import assign from 'lodash/assign'
import debounce from 'lodash/debounce'
import concat from 'lodash/concat'
import ActionButton from '@/components/Common/ActionButton'
import EndlessScroll from '@/components/Common/EndlessScroll'
import {Icons} from '@/components/mixins'
import {CompanyRoles} from '@/components/mixins'

// @group Company
// ReviewApplications component
export default {
  name: 'ReviewApplications',
  mixins: [Icons, CompanyRoles],
  components: {
    ActionButton,
    EndlessScroll
  },
  props: {
    items: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      applications: [],
      departments: [],
      noDepartment: [],
      options: {},
      showScroll: false,
      startAt: 0,
      sortBy: '',
      sortDesc: '',
      itemsPerPage: 25,
      gotAll: false,
      isLoading: false,
      appStatusIcon: '',
      showFilter: ['md', 'lg', 'xl'].includes(this.$vuetify.breakpoint.name)
    }
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isAdministrator']),
    ...mapGetters('basic', ['basicStates', 'getStateNameById'])
    //apps(){}
  },

  created() {
    this.init()
  },

  watch: {
    /**
     * @vuese
     * Used to watch currentUser and then call debouncedOnChange method
     */
    items: {
      handler() {
        this.init()
      },
      deep: true
    },
    options: {
      handler() {
        this.gotAll = false
        //this.$emit('fetch')
        const {sortBy, sortDesc, page, itemsPerPage} = this.options
        this.sortBy = sortBy
        this.sortDesc = sortDesc
        this.itemsPerPage = itemsPerPage
        this.startAt = (page - 1) * itemsPerPage
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication']),
    find: find,
    init() {
      this.applications = this.items

      //this.employees = this.emp      
      let appDep = []
      let noDep = []

      this.applications.forEach(ap => {
        if (ap.departments.length == 0) {
          noDep.push({
            id: ap.id,
            depId: -1,
            uniqId: ap.id + ':0',
            firstName: ap.firstName,
            lastName: ap.lastName,
            fullName: ap.fullName,
            createdAt: ap.createdAt,
            mobilephone: ap.mobilephone,
            depName: this.$t('company.missing-department'),
            email: ap.email,
            state: ap.state
          })
        } else {
          ap.departments.forEach(dep => {
            let addObject = true

            let findDep = -1
            if (this.isAdministrator != true) {
              if (this.getCurrentUserDepartmentsIds(this.$route.params.id, this.isAdministrator).length > 0) {
                findDep = this.getCurrentUserDepartmentsIds(this.$route.params.id, this.isAdministrator).find(x => x == dep.id)
              }

              if (!findDep > 0) {
                addObject = false
              }
            }
            if (addObject == true) {
              appDep.push({
                id: ap.id,
                depId: dep.id,
                uniqId: ap.id + ':' + dep.id,
                firstName: ap.firstName,
                lastName: ap.lastName,
                fullName: ap.fullName,
                createdAt: ap.createdAt,
                mobilephone: ap.mobilephone,
                depName: dep.name,
                email: ap.email,
                state: ap.state
              })
            }
          })
        }
      })

      appDep = uniqBy(appDep, 'uniqId')
      noDep = uniqBy(noDep, 'uniqId')
      
      this.departments = concat(appDep, noDep)
      // this.departments = sortBy(this.departments, [
      //   function (o) {
      //     return o.depName
      //   }
      // ])
    },
    /**
     * @vuese
     * Used to show an application
     * @arg The argument is the application id
     */
    showApplication(id) {
      API.getApplication(id)
        .then(response => {
          this.setSelectedApplication(response.data)
          this.$nextTick(() => {
            this.$router.push({
              name: 'AdminApplicationStart',
              params: {id: this.$route.params.id, application_id: id}
            })
          })
        })
        .catch(error => {
          console.log('There was an error getApplication:', error)
        })
    }
  }
}
</script>

<style lang="scss">
</style>